import { Box, Grid2, Typography } from '@mui/material'
import React, { useState, useRef, useEffect } from 'react'
import ToggleSwitch, { ToggleTwoSwitch } from '../../shared/utils/CustomToggle'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { useGetDemoSchooolList, useGetDemoPublisherlList } from '../../assets/api/useAdminApi'
import CustomAccordion from '../../shared/components/accordian/CustomAccordion'
import CustomDivider from '../../shared/utils/CustomDivider'
import PublisherDetails from './schoolpublisherdemo/PublisherDetails'
import SchoolDetails from './schoolpublisherdemo/SchoolDetails'
import SearchInput from '../../shared/components/student/SearchInput'
import { SkeletonCom } from '../../shared/utils/SkeletonCom'

const SchoolRequest = () => {
    const [searchKeyword, setSearchKeyword] = useState("")
    const [showPublisher, setShowPublisher] = useState(false);

    const handleToggleChange = (isChecked) => {
        setShowPublisher(isChecked);
    };


    // 👉 SCHOOL QUERY
    const schoolQuery = useGetDemoSchooolList();

    // 👉 PUBLISHER QUERY
    const publisherQuery = useGetDemoPublisherlList({ search: searchKeyword });

    // 👉 Dynamic Selection
    const activeQuery = showPublisher ? publisherQuery : schoolQuery;


    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading
    } = activeQuery;

    // 👉 Flatten Data
    const listData = data?.pages?.flatMap(p => p?.data || []) || [];

    // 👉 Observer
    const loadMoreRef = useRef(null);

    useEffect(() => {
        if (!loadMoreRef.current) return;

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasNextPage) {
                fetchNextPage();
            }
        });

        observer.observe(loadMoreRef.current);

        return () => observer.disconnect();
    }, [hasNextPage, fetchNextPage, showPublisher]); // important

    return (
        <Box>


            <NormalContainerWithHeader>

                <Grid2 container spacing={2}>
                    <Grid2 children size={8}>
                        <SearchInput
                            placeholder='Search by name.......'
                            onChange={(val) => {
                                setSearchKeyword(val)
                            }} />
                    </Grid2>
                    <Grid2 children size={4}>
                        <ToggleTwoSwitch
                            checked={showPublisher}
                            onCheck={handleToggleChange}

                        />

                    </Grid2>
                </Grid2>

                <CustomDivider />
                <Typography mb={3}>
                    {showPublisher ? "List Of Publisher" : "  List Of Schools"}
                </Typography>

                {
                    isLoading &&
                    [...Array(10)].map((_, index) => (
                        <Box key={index}>
                            <SkeletonCom height={100} />
                            <CustomDivider />
                        </Box>

                    ))
                }
                {
                    !isLoading && <>

                        {listData.map((item, index) => (
                            <Box key={item.id || index} sx={{ mb: 2 }}>



                                <CustomAccordion
                                    summary={
                                        !showPublisher
                                            ? (
                                                <Box display="flex" justifyContent="space-between" width="100%">

                                                    <Box>
                                                        <Typography variant='h5' fontWeight={600} sx={{ mb: 1 }}>
                                                            Course Name :  {item.course}
                                                        </Typography>
                                                        <Typography fontWeight={600} sx={{ mb: 1 }}>
                                                            {item.school_name}
                                                        </Typography>

                                                        <Typography fontSize={13}>
                                                            {item.address || "-"} , {item.city_name || ""} , {item.state_name || ""}     Contact Info : {item.contact_no || "-"}
                                                        </Typography>

                                                    </Box>
                                                </Box>
                                            )
                                            : (
                                                <Box>
                                                    <Typography variant='h5' fontWeight={600}>
                                                        Course Name :  {item.course}
                                                    </Typography>
                                                    <Typography fontWeight={600}>
                                                        {item.publisher_name}
                                                    </Typography>

                                                    <Typography fontSize={13}>
                                                        {item.address || "-"} , {item.city_name || ""} , {item.state_name || ""}
                                                    </Typography>
                                                </Box>
                                            )
                                    }

                                    details={
                                        !showPublisher
                                            ? <SchoolDetails school={item} />
                                            : <PublisherDetails publisher={item} />
                                    }

                                />

                                <CustomDivider size={"1rem"} />

                            </Box>
                        ))}
                    </>
                }



                <Box ref={loadMoreRef} sx={{ height: 40 }} />

                {isFetchingNextPage && <div>Loading more...</div>}

            </NormalContainerWithHeader>

        </Box>
    );
};

export default SchoolRequest;
